import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Saves the current page URL (path + query string) to sessionStorage
 * so sidebar links can restore filter state when navigating back.
 *
 * Key format: `lastUrl:<basePath>` e.g. `lastUrl:/orders`
 */
export function useRememberFilters() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Use the first path segment as the key (e.g. /orders, /trailers)
    // For root "/", use "/" as key
    const basePath = pathname === "/" ? "/" : "/" + pathname.split("/").filter(Boolean)[0];
    sessionStorage.setItem(`lastUrl:${basePath}`, `${pathname}${search}`);
  }, [pathname, search]);
}

/** Read the last-remembered URL for a given base path, falling back to the path itself. */
export function getLastFilterUrl(basePath: string): string {
  if (typeof window === "undefined") return basePath;
  return sessionStorage.getItem(`lastUrl:${basePath}`) || basePath;
}